import { createAction } from '@reduxjs/toolkit'

export const setBrushSize = createAction<number>('user/setBrushSize')
